// @ts-nocheck
import { currency, formatDate, } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
export default {
    remittanceTransactionAt: (state) => formatDate(state.remittance.data.transactionAt, dateFormatType.FULL_DATE),
    remittanceBaromoney: (state) => currency(state.remittance.data.remittanceBaromoney),
    remittanceMemo: (state) => state.remittance.data.memo || '-',
    remittanceReceiverName: (state) => state.remittance.receiver.name,
};
